import { useState } from 'react';

import { DatePicker, Input, Modal } from '@components';
import { isDateBefore } from '@features/group-management/helpers/customTerm';
import { formatISODate } from '@utils/date';

interface TermDueDateSelectionProps {
  dueDate: string;
  termStartDate: string;
  termEndDate: string;
  onDueDateChange: (date: string) => void;
  isDueDateDisabled: boolean;
  isDueDateError?: boolean;
  dueDateErrorMessage?: string;
}

const TermDueDateSelection = ({
  dueDate,
  termStartDate,
  termEndDate,
  onDueDateChange,
  isDueDateDisabled,
  isDueDateError,
  dueDateErrorMessage
}: TermDueDateSelectionProps) => {
  const [isDueDateModalOpen, setIsDueDateModalOpen] = useState<boolean>(false);
  const startDate = new Date(termStartDate);
  const minDate = startDate && startDate >= new Date() ? startDate : new Date();
  const maxDate = new Date(termEndDate);
  const isTermEndDateInPast = isDateBefore(termEndDate, new Date());
  const errorMessage = isTermEndDateInPast
    ? 'Due date must fall within the selected term duration.'
    : '';

  return (
    <>
      <Input
        leftIconName="calendar"
        value={
          dueDate && dueDate !== '' ? formatISODate({ date: dueDate }) : ''
        }
        onClick={() => {
          setIsDueDateModalOpen(true);
        }}
        placeholder="dd/mm/yyy"
        disabled={isDueDateDisabled}
        error={isDueDateError}
        errorMessage={dueDateErrorMessage}
        leftIconStyle={`${isDueDateDisabled ? '!opacity-50' : ''}`}
      />
      {isDueDateModalOpen && (
        <Modal
          isOpen={isDueDateModalOpen}
          onCancel={() => setIsDueDateModalOpen(false)}
        >
          <DatePicker
            confirmButtonLabel="Apply"
            confirmButtonStyle="text-primary"
            handleConfirm={(date) => {
              onDueDateChange(date);
              setIsDueDateModalOpen(false);
            }}
            cancelButtonLabel="Cancel"
            handleCancel={() => {
              setIsDueDateModalOpen(false);
            }}
            isMaxDateRequired
            minDate={minDate}
            maxDate={maxDate}
            selectedDate={(dueDate && new Date(dueDate)) || minDate}
            calendarStyle="!bg-bgBase"
            title="Select Due Date"
            errorMessage={errorMessage}
          />
        </Modal>
      )}
    </>
  );
};

export default TermDueDateSelection;
